import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import BaseModal from "../../theme/modals/BaseModal";
import BaseForm from "../../theme/forms/BaseForm";
import validators from "../../../utils/forms/validators";
import api from "../../../store/api";
import StaticMapboxImage from "../../theme/maps/staticMap";
import { proceedWithGeocodedData } from "../../../utils/projectStartSearch";

function AddressSearchModal({ visible, onClose = () => {} }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [geocodedData, setGeocodedData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errMsg, setErrMsg] = useState(null);

    const history = useHistory();

    const formInputs = [
        {
            type: 'text',
            dataKey: 'address',
            inputClasses: 'is-medium',
            controlClasses: 'full-width',
            placeholder: 'Enter Address',
            value: searchTerm,
            ...validators.isStringOfMinLength(4)
        }
    ];

    const onSubmit = ({ address }) => {
        setErrMsg(null);
        setLoading(true);
        return api
            .get('/geocode-address/', { address })
            .then((res) => {
                setLoading(false);
                if (!res.data || !res.data.address) {
                    setErrMsg("That address isn't valid");
                    return;
                }
                setSearchTerm(address);
                setGeocodedData(res.data);
            })
            .catch((err) => {
                setLoading(false);
                setErrMsg(err?.reject || "That address isn't valid");
            });
    };

    const handleConfirm = () => {
        if (geocodedData) {
            proceedWithGeocodedData(geocodedData, searchTerm, history);
            onClose();
        }
    };

    const handleBack = () => {
        setGeocodedData(null);
        setErrMsg(null);
    };

    return (
        <BaseModal visible={visible || true} onClose={onClose}>
            <h3 className="is-size-4 has-text-primary mb-3">Start a new project</h3>
            {errMsg && <p className="has-text-danger mt-2 mb-3">{errMsg}</p>}

            {geocodedData ? (
                <div>
                    <p className="subtitle is-size-6 mb-3">
                        Please confirm if the property location on the map is correct:
                    </p>
                    <p className="has-text-weight-semibold mb-3">
                        {geocodedData.address.formatted_address}
                    </p>
                    <div className="my-4 is-flex is-justify-content-center">
                        <StaticMapboxImage
                            latitude={geocodedData.address.lat}
                            longitude={geocodedData.address.lng}
                            img_height={250}
                            img_width={500}
                        />
                    </div>
                    <div className="buttons is-justify-content-flex-end mt-5">
                        <button
                            className="button is-primary"
                            onClick={handleConfirm}
                        >
                            Confirm & Proceed
                        </button>
                        <button
                            className="button is-warning"
                            onClick={handleBack}
                        >
                            Change Address
                        </button>
                        <button
                            className="button is-danger"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ) : (
                <div>
                    {loading && (
                        <div className="has-text-centered my-4">
                            <span className="icon is-large">
                                <i className="fas fa-spinner fa-pulse fa-2x" />
                            </span>
                            <p className="mt-2">Geocoding address...</p>
                        </div>
                    )}
                    <div className={loading ? "is-invisible" : ""}>
                        <BaseForm
                            inputs={formInputs}
                            buttonWrapperClass="is-justify-content-flex-end"
                            onSubmit={onSubmit}
                            onCancel={onClose}
                            submitButtonText="Get Financing"
                            disableAutocomplete
                        />
                    </div>
                </div>
            )}
        </BaseModal>
    );
}

export default AddressSearchModal;